import { render, staticRenderFns } from "./zygx.vue?vue&type=template&id=7cfc625d"
import script from "./zygx.vue?vue&type=script&lang=js"
export * from "./zygx.vue?vue&type=script&lang=js"
import style0 from "./zygx.vue?vue&type=style&index=0&id=7cfc625d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports